module.exports = __webpack_public_path__ + "static/media/FUTSAL’S SMOOTHIES.c80d55ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/FUTSAL’S SMOOTHIES.png
// module id = 328
// module chunks = 10